<template>
  <div class="w-full flex flex-col items-center justify-center">
    <SymbolTradeStateIcon :trading-state-code="tradingStateCode" size="large" />

    <div class="flex flex-col w-full mt-3">
      <NText
        v-if="tradingStateCode === TRADING_STATE_CODES.forbidden"
        variant="caption1"
        weight="regular"
      >
        {{ t('symbol.forbiddenTitle') }}
      </NText>

      <NText variant="caption1" weight="regular">
        {{ TRADING_STATE_INFO[tradingStateCode].description }}
      </NText>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TRADING_STATE_CODES } from '@core/symbol';
import { useI18n } from 'vue-i18n';

import { SymbolTradeStateIcon, TRADING_STATE_INFO } from '@/modules/symbol';

type SymbolTradeStateDialogPropsType = {
  tradingStateCode: number;
};

defineProps<SymbolTradeStateDialogPropsType>();

const { t } = useI18n();
</script>
